import { defineStore } from 'pinia'
import employmentTypeApi from '@/api/employment-type'


export const useEmplymentTypeStore = defineStore('employment-type', {
  state: () => ({
    employmentTypes: {}
  }),

  actions: {
    getEmploymentTypes({ data, success, fail } = {}) {
      employmentTypeApi.getEmploymentTypes(data).then(response => {
        this.employmentTypes = response.body.responseObject
        success && success(response)
      }, response => {
        fail && fail(response)
      })
    }
  },

})